import { useMemo } from 'react';
import { createContainer, createHook, createStore } from 'react-sweet-state';

// eslint-disable-next-line jira/restricted/@atlassian+jira-common-legacy
import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-common-util-get-tenant-context';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id';
import { MODAL } from '../../common/constants';
import { useSetIsYourWorkTourCompleted } from '../is-your-work-tour-completed';
import { type Actions, type StoreActions, actions as subscriberActions } from './actions';
import type { ContainerProps, YourWorkTourState } from './types';

export type { STEP } from './types';

export const initialState: YourWorkTourState = {
	currentStep: MODAL,
};

export const yourWorkTourStore = createStore<YourWorkTourState, StoreActions>({
	name: 'ITSMOnboardingYourWorkTour',
	initialState,
	actions: subscriberActions,
});

const useYourWorkTourStore = createHook(yourWorkTourStore);

export const YourWorkContainer = createContainer<YourWorkTourState, StoreActions, ContainerProps>(
	yourWorkTourStore,
	{
		displayName: 'FirstSessionFlowYourWorkTourContainer',
	},
);

// @ts-expect-error - TS7031 - Binding element 'cloudId' implicitly has an 'any' type. | TS7031 - Binding element 'end' implicitly has an 'any' type. | TS7031 - Binding element 'next' implicitly has an 'any' type. | TS7031 - Binding element 'setIsYourWorkTourCompleted' implicitly has an 'any' type. | TS7031 - Binding element 'next' implicitly has an 'any' type. | TS7031 - Binding element 'orgId' implicitly has an 'any' type.
const useActionsMemo = ({ cloudId, end, next, setIsYourWorkTourCompleted, orgId }): Actions =>
	useMemo(
		() => ({
			end: end({ cloudId, setIsYourWorkTourCompleted, orgId }),
			next: next({ cloudId, setIsYourWorkTourCompleted, orgId }),
		}),
		[end, cloudId, setIsYourWorkTourCompleted, orgId, next],
	);

const useStateMemo = ({ currentStep }: YourWorkTourState): YourWorkTourState =>
	useMemo(
		() => ({
			currentStep,
		}),
		[currentStep],
	);

export const useYourWorkTour = (): [YourWorkTourState, Actions] => {
	const [state, actions] = useYourWorkTourStore();
	const setIsYourWorkTourCompleted = useSetIsYourWorkTourCompleted();
	const { data: orgId } = useOrgId();
	const { cloudId } = getTenantContext_DEPRECATED_DO_NOT_USE();
	const memoizedActions = useActionsMemo({
		...actions,
		cloudId,
		setIsYourWorkTourCompleted,
		orgId,
	});
	const memoizedState = useStateMemo(state);
	return useMemo(() => [memoizedState, memoizedActions], [memoizedActions, memoizedState]);
};
